import { Component, OnInit } from '@angular/core';
import { ShiftDataService } from '../shift-data-analysis/shift-data.service';
import { DashboardService } from 'app/services/dashboard.service';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-select-site',
  templateUrl: './select-site.component.html',
  styleUrls: ['./select-site.component.scss']
})
export class SelectSiteComponent implements OnInit {

  sites: any[] = [];
  sitesCopy: any[] = [];

  constructor(
      public shiftDataService: ShiftDataService,
      public dialogRef: MatDialogRef<SelectSiteComponent>,
      public dashboardService: DashboardService
  ) {
  }

  ngOnInit(): void {
    // this.shiftDataService.siteselectDialogOpen = false;
    this.getSiteDetails();
  }

  onSiteSelect(site: any) {
    this.shiftDataService.selectedSiteSlaData = site;
    
    localStorage.setItem("selectedSiteSlaData",this.shiftDataService.selectedSiteSlaData);
    this.shiftDataService.selectedSiteToDisplaySiteDetails = site[0].site_name;
    this.shiftDataService.siteChangeEvent.emit();
    this.shiftDataService.siteSelectionEvent.emit();
    this.dialogRef.close();
  }

  getSiteDetails(){
      this.dashboardService.getMasterSiteInfo().subscribe(
          (res: any) => {
            // if(!this.shiftDataService.siteselectDialogOpen){
            //   this.shiftDataService.openSiteSelectionDialogComponent();
            // }
            let result = res.responseData[0].records.sort((a,b)=> a.site_name > b.site_name ? 1 : -1);
            this.sites = result;
            this.sitesCopy = result;
          });
  }
  onSiteSearch(value: any) {
      if (value) {
          this.sites = [...this.sitesCopy].filter((site) =>
              String(site.site_name)
                  .toLowerCase()
                  .indexOf(value.toLowerCase()) >= 0
                  ? site
                  : null
          );
      } else {
          this.sites = [...this.sitesCopy];
      }
  }

  onCloseBtnClick(){
    this.dialogRef.close();
  }

  onMenuClosed(){
    // if(this.shiftDataService.selectedSite.length === 0){
    //     this.masterSites.forEach((siteDetails) =>{
    //         this.shiftDataService.selectedSite.push(siteDetails.site_name);
    //     })
    //     // this.allSitesSelected = true;
    // }
    this.shiftDataService.selectedAssetIds = [];
    this.shiftDataService.siteChangeEvent.emit();
}
}
